import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useOnline } from '../services/connectivity';

// Shown across the top of every page while the API cannot be reached, and gone
// the moment a request gets through again. Staff need to know the difference
// between "the system is slow" and "nothing I save right now will reach the
// server", and nothing else on the page tells them.
const OfflineBanner = () => {
    const online = useOnline();
    const { t } = useTranslation();

    if (online) return null;

    return (
        <Alert
            banner
            type="warning"
            showIcon
            message={t('offlineBanner')}
            style={{ position: 'sticky', top: 64, zIndex: 99 }}
        />
    );
};

export default OfflineBanner;
